module.exports = __webpack_public_path__ + "img/habitantes_icone.c33509bc.png";